import React from 'react'
import { Formik, Field, Form } from "formik";
import * as yup from "yup";
import Heading from '../../shared/utils/Heading';
import { TextFormField } from '../../shared/components/FormFields/TextFormField';
import { Box, Button, Grid2 } from '@mui/material';
import CustomDivider from '../../shared/utils/CustomDivider';
import { Page_Padding } from '../../shared/constants';
import { PhoneInputFormField } from '../../shared/components/FormFields/PhoneInputFormField';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { useMutation } from '@tanstack/react-query';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import api from '../../assets/api/usePostApi';
import GoogleMapEmbed from '../../shared/utils/GoogleMap';
import api from '../../assets/nodeApi/axiosInstance';
import { useToaster } from '../../shared/utils/ToasterProvider';


const ContactUs = () => {
    const { showToaster } = useToaster();
    const validationSchema = yup.object().shape({
        first_name: yup.string().required('First Name is required'),
        last_name: yup.string().required('Last Name is required'),
        mobile_no: yup.string().test('is-phone', 'Phone number is not valid', function (value) {
            return value ? isValidPhoneNumber(value) : false;
        }),
        email: yup.string().email('Invalid email').required('Email is required'),
        message: yup.string().required('Message is required'),
    });

    const initialValues = {
        first_name: '',
        last_name: '',
        mobile_no: '',
        email: '',
        message: '',
    };

    const mutation = useMutation({
        mutationFn: (formData) => api.post("collab-contact/create", formData),
    });

    const handleSubmit = (values, { setSubmitting, resetForm }) => {
        mutation.mutate(values, {
            onSuccess: (response) => {
                if (response?.data) {
                    // toast.success(` ${response.data.message}`, {
                    //     position: "top-right",
                    //     autoClose: 3000,
                    //     hideProgressBar: false,
                    //     closeOnClick: true,
                    //     pauseOnHover: true,
                    //     draggable: true,
                    //     theme: "light",
                    // });
                    showToaster('Success', response?.data?.message, 'success');
                } else {
                    // toast.warning("Message sent, but no response from server.", {
                    //     position: "top-right",
                    //     autoClose: 3000,
                    //     theme: "light",
                    // });
                    showToaster('Error', "Message sent, but no response from server.", 'error');
                }

                resetForm();
            },
            onError: (error) => {
                console.error("Error Response:", error.response); // Log error response
                showToaster('Error', `Error sending message: ${error.response?.data?.message || error.message}`, 'error');

            },
            onSettled: () => {
                setSubmitting(false);
            }
        });
    };

    return (
        <Box className="body contact_us" px={Page_Padding}>
            <Heading Heading={"Reach out to us anytime—we're here to help!"} SubHeading={"Get in Touch With Us Today!"} />
            <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
                {({ isSubmitting }) => (
                    <Form>
                        <Grid2 container spacing={3}>
                            <Grid2 container size={{ lg: 6, xs: 12 }}>

                                <Grid2 children size={{ sm: 6, xs: 12 }}>
                                    <Field
                                        name="first_name"
                                        component={TextFormField}
                                        label="First Name"
                                        isRequired={true}
                                        type={"name"}
                                    />
                                </Grid2>
                                <Grid2 children size={{ sm: 6, xs: 12 }}>
                                    <Field
                                        name="last_name"
                                        component={TextFormField}
                                        label="Last Name"
                                        isRequired={true}
                                        type={"name"}
                                    />
                                </Grid2>
                                <Grid2 children size={12}>

                                    <Field
                                        name="mobile_no"
                                        component={PhoneInputFormField}
                                        label="Mobile No"
                                        isRequired={true}
                                    />
                                </Grid2>
                                <Grid2 children size={12}>
                                    <Field
                                        name="email"
                                        component={TextFormField}
                                        label="E-Mail"
                                        isRequired={true}
                                    />
                                </Grid2>
                            </Grid2>
                            <Grid2 container size={{ lg: 6, xs: 12 }}>
                                <Grid2 children size={12}>
                                    <Field
                                        name="message"
                                        component={TextFormField}
                                        label="Message"
                                        isRequired={true}
                                        multiline
                                        rows={4}
                                    />
                                </Grid2>

                                <Grid2 children size={12}>
                                    <Button variant='contained' fullWidth type='submit' disabled={isSubmitting}>
                                        {isSubmitting ? 'Submitting...' : 'Submit'}
                                    </Button>
                                </Grid2>
                            </Grid2>
                        </Grid2>
                    </Form>
                )}
            </Formik>
            <CustomDivider orientation='horizontal' />
            <CustomDivider orientation='horizontal' />
            <Heading Heading={"Feel free to stop by and visit us at our office, conveniently located for your convenience!"} SubHeading={"Where to Find Us"} />
            {/* <img src={Constants.customImages.LocationImg} alt='map' width={"100%"} height={"600px"} style={{ objectFit: "cover" }} /> */}
            <GoogleMapEmbed />
        </Box>
    )
}

export default ContactUs